import apiTenantsConfig from "../api-tenants.json";

function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined && window.ENV[name]) {
    return window.ENV[name];
  }

  return import.meta.env[name] || defaultValue;
}

const SELECTED_API_STORAGE_KEY = "selectedApiTenantId";
const DEFAULT_API_THEME_COLOR = "#0035a2";

function normalizeTenant(tenant, index) {
  const apiUrl = tenant?.apiUrl || tenant?.url || tenant?.backendUrl;
  if (!apiUrl) return null;

  return {
    id: tenant.id || `api-${index + 1}`,
    name: tenant.name || tenant.label || `API ${index + 1}`,
    apiUrl,
    themeColor: tenant.themeColor || tenant.color || DEFAULT_API_THEME_COLOR,
  };
}

function parseTenantLine(line, index) {
  const parts = line.split("|").map(part => part.trim());
  const [id, name, apiUrl, themeColor] = parts;
  if (!apiUrl) return null;

  return normalizeTenant({ id, name, apiUrl, themeColor }, index);
}

function parseTenants(rawTenants) {
  if (!rawTenants) return [];

  try {
    const parsed = JSON.parse(rawTenants);
    if (!Array.isArray(parsed)) return [];
    return parsed.map(normalizeTenant).filter(Boolean);
  } catch (_error) {
    return rawTenants
      .split(";")
      .map(parseTenantLine)
      .filter(Boolean);
  }
}

export function getApiTenants() {
  const tenants = Array.isArray(apiTenantsConfig)
    ? apiTenantsConfig.map(normalizeTenant).filter(Boolean)
    : [];
  if (tenants.length > 0) return tenants;

  const envTenants = parseTenants(getConfig("VITE_API_TENANTS"));
  if (envTenants.length > 0) return envTenants;

  const defaultUrl = getConfig("VITE_BACKEND_URL");
  return defaultUrl
    ? [{ id: "default", name: "Padrao", apiUrl: defaultUrl }]
    : [];
}

export function getSelectedApiTenant() {
  const tenants = getApiTenants();
  const selectedId = localStorage.getItem(SELECTED_API_STORAGE_KEY);
  return tenants.find(tenant => tenant.id === selectedId) || tenants[0] || null;
}

export function setSelectedApiTenant(tenantId) {
  const tenants = getApiTenants();
  const tenant = tenants.find(item => item.id === tenantId);
  if (!tenant) return null;

  localStorage.setItem(SELECTED_API_STORAGE_KEY, tenant.id);
  window.dispatchEvent(new CustomEvent("apiTenantChanged", { detail: tenant }));
  return tenant;
}

export function clearApiSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
}

export function getBackendUrl() {
  return getSelectedApiTenant()?.apiUrl || getConfig("VITE_BACKEND_URL");
}

export function getSelectedApiThemeColor() {
  return getSelectedApiTenant()?.themeColor || DEFAULT_API_THEME_COLOR;
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}
